module.exports = __webpack_public_path__ + "src/assets/img/sultan-selector-navigation.6d44ef34.png";